export default __webpack_public_path__ + "static/media/port4.50933113.png";